//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Upload from '@/components/Upload/Upload'
import api from '@/api/api'
export default {
  name: 'face_page',
  data() {
    return {
      showUpload: false
    }
  },
  computed: {
    token() {
      return this.$store.state.base.qiniuToken
    }
  },
  mounted() {},
  methods: {
    uploaded(url) {
      let _this = this
      let liveId = this.$route.params.liveId
      _this.$vux.loading.show({
        text: '面孔智能识别中...'
      })
      // 调用人脸识别接口
      this.$store
        .dispatch({
          type: 'getFaceList',
          liveId: liveId,
          url: url
        })
        .then(() => {
          _this.$vux.loading.hide()
          // 跳转到人脸识别结果页面
          this.$router.push({
            name: 'FaceRecogPage',
            params: { liveId: liveId }
          })
        })
        .catch(err => {
          _this.$vux.loading.hide()
          _this.$vux.toast.show({
            type: 'warn',
            text: err.data.Message
          })
          setTimeout(() => {
            _this.$vux.toast.hide()
          }, 3000)
        })
    },
    showUpPanel() {
      this.showUpload = true
      this.$refs.upload.init()
    },
    close() {
      this.showUpload = false
    }
  },
  components: {
    Upload
  }
}



// WEBPACK FOOTER //
// ./src/components/FaceRecog/FaceRecog.vue